var _defs, _rect, _path, _path2, _ellipse, _path3, _ellipse2, _path4, _text, _path5, _ellipse3, _path6, _ellipse4, _path7, _path8, _text2, _path9, _ellipse5, _path10, _ellipse6, _path11, _text3, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTankerLen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "652px",
    height: "383px",
    viewBox: "-0.5 -0.5 652 383",
    content: "<mxfile modified=\"2019-03-16T10:52:17.950Z\" host=\"www.draw.io\" agent=\"Mozilla/5.0 (Macintosh; Intel Mac OS X 10_14_2) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/73.0.3683.75 Safari/537.36\" etag=\"PvfE7AoXJFr1U_LKc21G\" version=\"10.4.8\" type=\"device\"><diagram id=\"-nS0Chg_5Lkkhu5DVkY9\" name=\"Page-1\">7Vlbb9owFP41PIJyDzxyKZs0qlVjWqW9VCYxiTcnzhIz6H797MQOMXEHnQhodEUqyTm+xN/n75zj0LOnye5dDrL4noQQ9ywj3PXsWc+yfMdm/7nhuTI4rjBEOQork7k3LNEvKIyGsG5QCAulISUEU5SpxoCkKQyoYgN5TrZqszXB6qwZiGDLsAwAblsfUUhjYTW90d7xHqIoFlMPLb9yJEA2FispYhCSbcNk3/XsaU4Ira6S3RRijp3Epeo3f8FbP1gOU3pKhw9P5Os37K/HXxa7BaLIKRy/77rVMD8B3ogVi6elzxKCnGzSEPJRjJ492caIwmUGAu7dMs6ZLaYJZncmuxTDwZzC3YsPatbLZ9sGkgTS/Jk1kR2GAjGxZUxX3G/3BNjCFDehFzYgKI/qkfeosAsBzCtAckbHQWpAoEMoIAkKhL+gOfle7yYGxGRNUjoHCcJ8xdOyqWUsQVqwr/ulaLAUk/Eh1gjjKcEkLye3QwCH66AeuuHxgiFcrc/Di6/SYjnDFi2eq+HFMqyOiLH948TwJSOm5wVYQfxACtaXpMy1IpSShCFDNhSjlIEmAwjf5QCjiLcKGDaQYTkJQRHXGmiQLYcfiw6UcLqZ1jM+f7KLeFQcZCgcJKgIBkWMsnNIxFO5kNGoQYVr6agwO9OIeZwKBcOjvOiRbRFzCHWUhHhQYJY18hkqwArD0NIpY2Xwj16OqrrqljFIQwxFjvKquauQXnrZIvimMIzzyM2RqVNwbDtOi2TL0JDcHcfWbXKckhSeSu+ZyD0UsG20c1xNpBpMuyJXVwl4mIrso7Ds/dgQ6egXJWBj1sAcZru9k11F/HvxcSwHYg9WjVV5WpuH4UnV8JpDNjwnWECfEZTScunupOfO+GbZUFI9QtlB7h0M1/Tl8MySM0qjz/xm1nfOpFfDU/PjqJ0f9emxI0blZH+Sq1QWWyZFAH9iGRCkEfceK/RKJEtOpJrLG42u2kWJP56M5t0IyfQ0qOtSoel0hvuNpsJrhEnfPciB7TBpDv1LiupGc+AV65zDc4Umbl42FcpXFLcdOH1HhV0WAA3Ya2rU8tLpCnenqxLkcfEmShDbH6nhUh6Qr1aCeG9BSQfvq+pg1VSS52mUNOoM9xNejPzPUq87jfuqtIbtVy7m6KKVyAlvJf9Fjq9RZh4o2B5pykzvkoHT053dzpIKHx7eZirU6PWiqdA74VT4lwptMHSozRUoUDAgOY1JRFKAn2iOZHZtCXRe/nGeCQVi6r7nnocQ17cUQuqjXVNjuteZ/usZYbf739VKX+PHSfvuNw==</diagram></mxfile>",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 81,
    width: 30,
    height: 80,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 1 179 L 1 178.79 L 11 178.34 L 21 179.19 L 31 179.02 L 41 179.3 L 51 178.28 L 61 179.2 L 71 178.73 L 81 179.35 L 91 178.54 L 101 178.53 L 111 179.28 L 121 179.61 L 131 178.32 L 141 179.03 L 151 178.62 L 161 178.75 L 171 178.56 L 181 178.51 L 191 179.2 L 201 179.43 L 211 178.59 L 221 178.41 L 231 179.21 L 241 179.32 L 251 178.98 L 261 178.99 L 271 178.86 L 281 179.33 L 291 179.4 L 301 179.19 L 311 178.76 L 321 179.3 L 331 179.68 L 341 179.17 L 351 178.94 L 361 178.76 L 371 178.67 L 381 179.11 L 391 179.5 L 401 179.52 L 411 178.66 L 421 179.04 L 431 178.51 L 441 179.03 L 451 179.41 L 461 178.93 L 471 179.23 L 481 179.45 L 491 179.25 L 501 178.42 L 511 179.21 L 521 178.91 L 531 179.29 L 541 178.45 L 551 179.6 L 561 179.7 L 571 179.13 L 581 178.3 L 591 179.46 L 601 178.41 L 611 178.72 L 621 178.97 L 631 178.89 L 641 179.14 L 651 179 L 651.46 179 L 651.2 189.1 L 650.59 199.2 L 651.68 209.3 L 651.11 219.4 L 650.97 229.5 L 650.41 239.6 L 650.61 249.7 L 651.19 259.8 L 650.56 269.9 L 651.3 280 L 650.41 290.1 L 651.5 300.2 L 651.02 310.3 L 651.72 320.4 L 651.51 330.5 L 650.52 340.6 L 650.74 350.7 L 650.97 360.8 L 651.29 370.9 L 651 381 L 651 380.51 L 641 380.93 L 631 380.52 L 621 380.6 L 611 381.26 L 601 381.68 L 591 380.73 L 581 381.58 L 571 380.95 L 561 380.94 L 551 381.75 L 541 380.46 L 531 381.14 L 521 380.4 L 511 381.57 L 501 380.84 L 491 381.53 L 481 380.56 L 471 380.73 L 461 381.4 L 451 380.88 L 441 380.95 L 431 380.54 L 421 381.74 L 411 380.35 L 401 380.9 L 391 381.59 L 381 380.32 L 371 381.5 L 361 380.47 L 351 381.48 L 341 381.63 L 331 381.24 L 321 381.03 L 311 381.14 L 301 380.47 L 291 380.6 L 281 381.62 L 271 381.56 L 261 380.37 L 251 380.59 L 241 381.24 L 231 381.02 L 221 381.11 L 211 380.56 L 201 381.19 L 191 381.7 L 181 381.31 L 171 380.5 L 161 380.96 L 151 380.32 L 141 381.4 L 131 380.67 L 121 380.51 L 111 380.43 L 101 380.43 L 91 380.32 L 81 380.45 L 71 381.35 L 61 380.45 L 51 381.34 L 41 380.44 L 31 380.67 L 21 381.62 L 11 380.6 L 1 381 L 1.23 381 L 0.49 370.9 L 0.43 360.8 L 0.51 350.7 L 1.09 340.6 L 1.72 330.5 L 0.33 320.4 L 0.82 310.3 L 1.69 300.2 L 1.31 290.1 L 1.75 280 L 1.68 269.9 L 1.48 259.8 L 0.55 249.7 L 0.87 239.6 L 0.7 229.5 L 0.68 219.4 L 0.74 209.3 L 0.43 199.2 L 0.89 189.1 L 1 179 L 1 179 Z Z",
    fill: "#dae8fc",
    stroke: "#6c8ebf",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 91 140 L 437.67 140 L 437.67 122.5 L 611 105 L 561.48 210 L 115.76 210 Z M 214.81 70 L 264.33 70 L 264.33 140 L 165.29 140 L 165.29 105 L 214.81 105 Z M 264.33 0 L 264.33 70",
    fill: "#ffffff",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 574,
    cy: 280,
    rx: 3,
    ry: 3,
    fill: "#b0b0b0",
    stroke: "#b0b0b0",
    strokeWidth: 2,
    pointerEvents: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 374 280 L 567 280",
    fill: "none",
    stroke: "#b0b0b0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 91,
    cy: 241,
    rx: 3,
    ry: 3,
    fill: "none",
    stroke: "#b0b0b0",
    strokeWidth: 2,
    pointerEvents: "none"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 98 241 L 301 241",
    fill: "none",
    stroke: "#b0b0b0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(338.5,231.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "all",
    width: 36,
    height: 19,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      verticalAlign: "top",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 18
    }
  }, "LOA")))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 18,
    y: 16,
    fill: "#000000",
    textAnchor: "middle",
    fontSize: "12px",
    fontFamily: "Helvetica"
  }, "[Not supported by viewer]")))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 91 99 M 611 99 L 611 239 M 91 239 L 91 98.5",
    fill: "none",
    stroke: "#67ab9f",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 106,
    cy: 281,
    rx: 3,
    ry: 3,
    fill: "none",
    stroke: "#b0b0b0",
    strokeWidth: 2,
    pointerEvents: "none"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 113 281 L 293 281",
    fill: "none",
    stroke: "#b0b0b0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 611,
    cy: 239,
    rx: 3,
    ry: 3,
    fill: "#b0b0b0",
    stroke: "#b0b0b0",
    strokeWidth: 2,
    pointerEvents: "none"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 401 239 L 604 239",
    fill: "none",
    stroke: "#b0b0b0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 105 176 M 575 176 L 575 280 M 105 280 L 105 175.5",
    fill: "none",
    stroke: "#67ab9f",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(311.5,270.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "all",
    width: 36,
    height: 19,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      verticalAlign: "top",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 18
    }
  }, "LWL")))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 18,
    y: 16,
    fill: "#000000",
    textAnchor: "middle",
    fontSize: "12px",
    fontFamily: "Helvetica"
  }, "[Not supported by viewer]")))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M 111 141 M 577 141 L 577 331 M 111 331 L 111 140.5",
    fill: "none",
    stroke: "#67ab9f",
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 575,
    cy: 330,
    rx: 3,
    ry: 3,
    fill: "#b0b0b0",
    stroke: "#b0b0b0",
    strokeWidth: 2,
    pointerEvents: "none"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M 378 330 L 568 330",
    fill: "none",
    stroke: "#b0b0b0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 111,
    cy: 331,
    rx: 3,
    ry: 3,
    fill: "none",
    stroke: "#b0b0b0",
    strokeWidth: 2,
    pointerEvents: "none"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M 118 331 L 271 331",
    fill: "none",
    stroke: "#b0b0b0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(311.5,322.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "all",
    width: 34,
    height: 19,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      verticalAlign: "top",
      whiteSpace: "nowrap"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 18
    }
  }, "LPP")))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 17,
    y: 16,
    fill: "#000000",
    textAnchor: "middle",
    fontSize: "12px",
    fontFamily: "Helvetica"
  }, "[Not supported by viewer]")))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M 503 176 L 503 106 L 603 176 Z",
    fill: "#ffffff",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    transform: "rotate(-65,553,141)",
    pointerEvents: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTankerLen);
export default __webpack_public_path__ + "static/media/tanker_len.f57d96960f31797219479925fadc0993.svg";
export { ForwardRef as ReactComponent };